const PollQueryKeys = {
  global: ["polls"] as const,
  poll: (id: string) => [...PollQueryKeys.global, "poll", id] as const,
};

export { PollQueryKeys };
